import React, { useState } from "react";

import { Icon } from "@iconify/react";
import { Typography } from "antd";

import AddCardModal from "js/components/Memberships/AddCardModal";

import "styles/components/Memberships/emptyCard.scss";

const EmptyCard = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { Text } = Typography;

  return (
    <>
      <div className="empty-card" onClick={() => setIsModalOpen(true)}>
        <div>
          <Icon icon="carbon:add-filled" fontSize={50} color={"#3881ff"} />
        </div>
        <div>
          <Text>Agregar nueva tarjeta</Text>
        </div>
      </div>
      <AddCardModal isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} />
    </>
  );
};

export default EmptyCard;
